import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBy',
    standalone: false
})
export class FilterByPipe implements PipeTransform {
    transform(list: any[], searchTerm: string, properties: string[]): any[] {
        if (searchTerm && properties?.length > 0) {
            return list.filter((item) => {
                return properties.some((property) => {
                    const propValue = item[property];
                    return propValue.toLowerCase().includes(searchTerm.toLowerCase());
                });
            });
        } else {
            return list;
        }
    }
}
